exports.gaEvent = (message) => {
  console.log('ga event')
  this.$ga.event(this.$dayjs().format('YYYY-MM-DD HH:mm:ss'), message)
}
/**
 *
 * page 명
 */



// WEBPACK FOOTER //
// ./src/ga.js